'use client';
import { Dispatch, SetStateAction, useState } from 'react';
import { DialogDescription } from '@radix-ui/react-dialog';
import ErrorIcon from '@/components/customercenter-ui/svgs/notifications/error';
import SuccessIcon from '@/components/customercenter-ui/svgs/notifications/success';
import { useAccount } from '@/frontastic';
import { ErrorNotification, SuccessNotification } from '@/helpers/utils/notification';
import { AddressPayload } from '@/sdk/composable-commerce/types/payloads/AccountPayloads';
import { RESPONSE_SUCCESS_MESSAGE } from '../../customer-detail/constants';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import Loader from '../../ui/loader';
import { useToast } from '../../ui/use-toast';

interface ConfirmAddress {
  Texts: { [key: string]: string };
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  updatedAddressPayload: AddressPayload;
  getAddressUpdateStatus: (status: boolean) => void;
}

const ConfirmEditAddressModal = ({
  Texts,
  open,
  setOpen,
  updatedAddressPayload,
  getAddressUpdateStatus,
}: ConfirmAddress) => {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const { updateCustomerAddress } = useAccount();

  const updateAddress = async () => {
    setLoading(true);
    await updateCustomerAddress(updatedAddressPayload).then((res) => {
      if (res?.code === RESPONSE_SUCCESS_MESSAGE) {
        SuccessNotification(toast, { description: Texts.addressEdited, action: <SuccessIcon className="h-5 w-5" /> });
        getAddressUpdateStatus?.(true);
      } else {
        ErrorNotification(toast, {
          description: Texts.errorUpdatingAddress,
          action: <ErrorIcon className="h-5 w-5" />,
        });
        getAddressUpdateStatus?.(false);
      }
      setLoading(false);
      setOpen(false);
    });
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        setOpen(value);
      }}
    >
      <DialogContent className="max-w-[520px] bg-white sm:rounded-md">
        {loading && <Loader />}
        <DialogHeader>
          {/* chng-text-25px */}
          <DialogTitle className="text-2xl font-bold">{Texts.confirmation}</DialogTitle>
          <DialogDescription>
            <p className="text-base font-normal">{Texts.confirmationMessage}</p>
          </DialogDescription>
        </DialogHeader>

        <section className="mt-4 flex justify-start gap-4">
          <Button
            className="rounded-md bg-deepBlue p-4 text-white"
            onClick={() => {
              updateAddress();
            }}
          >
            {Texts.updateAddressMessage}
          </Button>
          <Button className="p-0 underline" onClick={() => setOpen(false)}>
            {Texts.cancel}
          </Button>
        </section>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmEditAddressModal;
